module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo12-78666c751a242ebcdbdd9a7047a8d8ce.jpg";